module.exports = __webpack_public_path__ + "static/media/pressCoverage.97591dd0.csv";